<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<jiyangList></jiyangList>
		</div>
		<div class="add" v-if="type==='add'">
			<jiyangAdd></jiyangAdd>
			<div class="settlementBox">
				<jiyangSettlement></jiyangSettlement>
			</div>
		</div>
	</div>
</template>
<script>
	import jiyangAdd from "./comp/jiyang_add.vue"
	import jiyangList from "./comp/jiyang_list.vue"
	import jiyangSettlement from "./comp/jiyang_settlement.vue"
	export default {
		components:{jiyangAdd,jiyangList,jiyangSettlement},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.jiyang.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	position: relative;
	width:100%;
	height: 100%;
	background-color: #fff;
	.settlementBox{
		position: absolute;
		bottom:0;
		width:100%;
	}
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
